// src/constants/skillLevels.js

export const skillLevels = [
  "未経験",
  "見学済み",
  "経験1回",
  "経験2回",
  "経験3回以上",
  "外から見守り",
  "独り立ち",
  "指導可"
];

export const skillScoreMap = {
  "未経験": 0,
  "見学済み": 1,
  "経験1回": 2,
  "経験2回": 3,
  "経験3回以上": 4,
  "外から見守り": 5,
  "独り立ち": 6,
  "指導可": 7
};

// skillLevelLabels を level番号 → ラベルの対応表として作成
export const skillLevelLabels = Object.fromEntries(
  skillLevels.map((label, index) => [index + 1, label])
);
